import { apiGetAuth, apiPostAuth, apiPostAuthWithConfig, apiPatchAuth } from '@/utils/api'
import { API_PROMO_MANAGEMENT, API_CONSUMER, API_ORION_PRODUCT } from '@/utils/api-url'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    promo: { data: [] },
    detail_promo: { data: [] },
    consumers: { data: [] },
    data_modal_add_edit: {},
    data_bulk_promo: [],
    data_bulk_promo_temp: [],
    bulk_status: '',
    upload_percentage: 0,
    is_uploading: false,
    is_processing: false,
    upload_id: null,
    products: {},
    stores: {},
    meta_filter: {},
    detail_consumer: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    },
    percentage_verify: 0
  }
}

const mutations = {
  SET_PROMO (state, payload) {
    state.promo = payload
  },
  SET_DETAIL_PROMO (state, payload) {
    state.detail_promo = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload){
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  },
  SET_BULK_PROMO(state, payload) {
    state.data_bulk_promo = payload
  },
  SET_BULK_PROMO_TEMP(state, payload) {
    state.data_bulk_promo_temp = payload
  },
  SET_BULK_STATUS(state, payload) {
    state.bulk_status = payload
  },
  SET_UPLOAD_PERCENTAGE(state, payload) {
    state.upload_percentage = payload
  },
  SET_IS_UPLOADING(state, payload) {
    state.is_uploading = payload
  },
  SET_IS_PROCESSING(state, payload) {
    state.is_processing = payload
  },
  SET_UPLOAD_ID(state, payload) {
    state.upload_id = payload
  },
  SET_CONSUMERS (state, payload) {
    state.consumers = payload
  },
  SET_PRODUCT (state, payload) {
    state.products = payload
  },
  SET_STORE (state, payload) {
    state.stores = payload
  },
  SET_DETAIL_CONSUMER (state, payload) {
    state.detail_consumer = payload
  },
  SET_PERCENTAGE_VERIFY (state, payload) {
    state.percentage_verify = payload
  }
}

const actions = {
  async getDetailConsumer (context, payload) {
    try {
      const response = await apiGetAuth(API_CONSUMER.DETAIL_CONSUMER(payload))
      context.commit('SET_DETAIL_CONSUMER', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListConsumer (context, payload) {
    try {
      const response = await apiGetAuth(API_CONSUMER.LIST_CONSUMER, payload)
      if(response.data.data){
        context.commit('SET_CONSUMERS', response.data.data)
      } else {
        context.commit('SET_CONSUMERS', [])
      }
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListPromo (context, payload) {
    try{
      const response = await apiGetAuth(API_PROMO_MANAGEMENT.LIST_PROMO_MANAGEMENT, payload)
      context.commit('SET_PROMO', response.data)
    }catch (error){
      notificationDanger(error)
    }
  },
  async getDetailPromo (context, payload) {
    try {
      const response = await apiGetAuth(API_PROMO_MANAGEMENT.DETAIL_PROMO_MANAGEMENT(payload))
      context.commit('SET_DETAIL_PROMO', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updatePromo (context, payload) {
    try {
      const response = await apiPatchAuth(API_PROMO_MANAGEMENT.UPDATE_PROMO_MANAGEMENT(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async createPromo (context, payload) {
    try {
      const response = await apiPostAuth(API_PROMO_MANAGEMENT.CREATE_PROMO_MANAGEMENT, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async uploadBulkPromo (context, payload) {
    try {
      context.commit('SET_IS_UPLOADING', true)
      const response = await apiPostAuthWithConfig(API_PROMO_MANAGEMENT.UPLOAD_BULK_PROMO_MANAGEMENT, payload, {
        onUploadProgress: (e) => {
          const percent = Math.round((e.loaded * 100) / e.total)
          context.commit('SET_UPLOAD_PERCENTAGE', percent)
        }
      })
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
      throw error
    } finally {
      context.commit('SET_IS_UPLOADING', false)
      context.commit('SET_UPLOAD_PERCENTAGE', 0)
    }
  },
  async verifyBulkPromo (context, payload) {
    try {
      const response = await apiPostAuth(API_PROMO_MANAGEMENT.VERIFY_BULK_PROMO_MANAGEMENT, payload)
      context.commit('SET_BULK_PROMO', response.data.data)
      context.commit('SET_PERCENTAGE_VERIFY', 0)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      context.commit('SET_PERCENTAGE_VERIFY', 0)
      notificationDanger(error)
      throw error
    }
  },
  async confirmBulkPromo (context, payload) {
    try {
      const response = await apiPostAuth(API_PROMO_MANAGEMENT.CONFIRM_BULK_PROMO_MANAGEMENT, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async statusBulkPromo () {
    try {
      const response = await apiGetAuth(API_PROMO_MANAGEMENT.STATUS_BULK_PROMO_MANAGEMENT)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getBulkUploadStatus (_context, payload) {
    try {
      const response = await apiGetAuth(API_PROMO_MANAGEMENT.BULK_UPLOAD_STATUS, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
      throw error
    }
  },
  async pollBulkStatus (context, payload) {
    return new Promise((resolve, reject) => {
      let intervalId = null
      let cancelled = false

      const stopPolling = () => {
        if (intervalId) {
          clearInterval(intervalId)
          intervalId = null
        }
      }

      const poll = async () => {
        if (cancelled) return

        try {
          const response = await context.dispatch('getBulkUploadStatus', { upload_id: payload.upload_id })

          if (cancelled) return

          const status = response?.data?.status
          const progress = response?.data?.progress
          context.commit('SET_PERCENTAGE_VERIFY', progress)
          
          if (status === 'completed') {
            stopPolling()
            resolve({ data: response.data, intervalId })
          } else if (status === 'failed') {
            stopPolling()
            reject(new Error('Upload processing failed'))
          }
        } catch (error) {
          stopPolling()
          context.commit('SET_PERCENTAGE_VERIFY', 0)
          if (!cancelled) {
            reject(error)
          }
        }
      }

      const cancelPolling = () => {
        cancelled = true
        stopPolling()
      }

      if (payload.onCancelRegistered) {
        payload.onCancelRegistered(cancelPolling)
      }

      poll()

      intervalId = setInterval(poll, 10000)

      if (payload.onIntervalCreated) {
        payload.onIntervalCreated(intervalId)
      }
    })
  },
  async getListProduct (context, payload) {
    try {
      const response = await apiGetAuth(API_ORION_PRODUCT.LIST_PRODUCT, payload)
      if(response.data.data){
        context.commit('SET_PRODUCT', response.data.data)
      } else {
        context.commit('SET_PRODUCT', [])
      }
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListStore (context, payload) {
    try {
      const response = await apiGetAuth(API_PROMO_MANAGEMENT.LIST_STORE, payload)
      if(response.data.data){
        context.commit('SET_STORE', response.data.data)
      } else {
        context.commit('SET_STORE', [])
      }
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  list_promo_management (state) {
    return state.promo
  },
  detail_promo_management (state) {
    return state.detail_promo
  },
  list_bulk_promo (state){
    return state.data_bulk_promo
  },
  list_bulk_promo_temp (state){
    return state.data_bulk_promo_temp
  },
  get_bulk_status (state){
    return state.bulk_status
  },
  get_upload_percentage (state){
    return state.upload_percentage
  },
  get_is_uploading (state){
    return state.is_uploading
  },
  get_is_processing (state){
    return state.is_processing
  },
  get_upload_id (state){
    return state.upload_id
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_list_consumer (state) {
    return state.consumers
  },
  get_detail_consumer (state){
    return state.detail_consumer
  },
  meta_filter (state) {
    return state.meta_filter
  },
  get_list_product (state) {
    return state.products
  },
  get_list_store (state) {
    return state.stores
  },
  get_percentage_verify (state) {
    return state.percentage_verify
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
